import { MatDialogModule, MAT_DIALOG_DEFAULT_OPTIONS, MatIconModule, MAT_DATE_LOCALE } from '@angular/material';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { AppRoutes } from './app.routing';
import { AppComponent } from './app.component';

import { FlexLayoutModule } from '@angular/flex-layout';
import { FullComponent } from './layouts/full/full.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DemoMaterialModule } from './demo-material-module';
import { MatExpansionModule } from '@angular/material/expansion';

import { LoginTesteComponent } from './login-teste/login-teste.component';
import { CadastroComponent } from './cadastro/cadastro.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgxMaskModule} from 'ngx-mask';
import { LoadingService } from './interceptor/loading.service';
import { MensagemSucessoComponent } from './modal/mensagem-sucesso/mensagem-sucesso.component';
import { MensagemErroComponent } from './modal/mensagem-erro/mensagem-erro.component';
import { MensagemAvisoComponent } from './modal/mensagem-aviso/mensagem-aviso.component';
import { RecaptchaModule } from 'ng-recaptcha';
import { ObservacaoAnexosComponent } from './modal/observacao-anexos/observacao-anexos.component';

// export const options: Partial<IConfig> | (() => Partial<IConfig>);

@NgModule({
  declarations: [
    AppComponent,
    FullComponent,
    LoginTesteComponent,
    CadastroComponent,
    MensagemSucessoComponent,
    MensagemErroComponent,
    MensagemAvisoComponent,
    ObservacaoAnexosComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    DemoMaterialModule,
    FormsModule,
    FlexLayoutModule,
    HttpClientModule,
    NgxSpinnerModule,
    MatDialogModule,
    MatIconModule,
    RecaptchaModule,
    MatExpansionModule,
    RouterModule.forRoot(AppRoutes),
    NgxMaskModule.forRoot()
  ],
  providers: [
    {
      provide: LocationStrategy,
      useClass: PathLocationStrategy
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingService,
      multi: true
    },
    {provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: {hasBackdrop: false}},
    {provide: MAT_DATE_LOCALE, useValue: 'pt-br'}
  ],
  entryComponents: [MensagemErroComponent, MensagemAvisoComponent, MensagemSucessoComponent, ObservacaoAnexosComponent],
  bootstrap: [AppComponent]
})
export class AppModule {}
